import { useMutation, useQuery } from 'react-query';
import BoschServices from './Bosch.services';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { WORKORDER_COMPLEMENT_DETAIL_KEY } from '../WorkOrdersComplements/WorkOrdersComplements.hooks';

const QUERY_BOSCH_CORE_CONFIG_DETAIL = 'bosch-core-config/detail';

export function useBoschJobCardCreate() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: BoschServices.createJobCard,
    onSuccess(_, complementId) {
      notification.success({
        message: 'Ticket de diagnóstico gerado no CoRe com sucesso!',
      });
      queryChanel({
        refetchQueries: [[WORKORDER_COMPLEMENT_DETAIL_KEY, complementId]],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useBoschReport() {
  return useMutation({
    mutationFn: BoschServices.downloadReport,
    onSuccess() {
      notification.success({
        message: 'Relatório gerado com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useBoschCoreConfigCreate() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: BoschServices.createConfig,
    onSuccess(_, vars) {
      notification.success({
        message: 'Credencial do Bosch CoRe salvo com sucesso!',
      });
      queryChanel({
        invalidateQueries: [[QUERY_BOSCH_CORE_CONFIG_DETAIL, vars.companyId]],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useBoschCoreConfigUpdate() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: BoschServices.updateConfig,
    onSuccess(_, vars) {
      notification.success({
        message: 'Credencial do Bosch CoRe atualizado com sucesso!',
      });
      queryChanel({
        invalidateQueries: [[QUERY_BOSCH_CORE_CONFIG_DETAIL, vars.companyId]],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useBoschCoreConfigRemove() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: BoschServices.removeConfig,
    onSuccess(_, companyId) {
      notification.success({
        message: 'Credencial do Bosch CoRe removido com sucesso!',
      });
      queryChanel({
        invalidateQueries: [[QUERY_BOSCH_CORE_CONFIG_DETAIL, companyId]],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useBoschCoreConfigDetail(companyId?: number) {
  return useQuery({
    queryKey: [QUERY_BOSCH_CORE_CONFIG_DETAIL, companyId],
    queryFn: () => BoschServices.detailConfig(companyId),
    enabled: !!companyId,
  });
}
